import React, { Component } from 'react';
import OgaSelect from "../elements/OgaSelect";

export default class DptSelect extends Component {

    constructor(props) {
        super(props);
    }

    handleChange = (status) => {
        this.props.handleChange(status);
    }

    render() {
        const statuses = [
            { value: null, label: 'Seleccionar Dpto.' },
            { value: 'BN', label: 'Beni' },
            { value: 'CH', label: 'Chuquisaca' },
            { value: 'CB', label: 'Cochabamba' },
            { value: 'LP', label: 'La Paz' },
            { value: 'OR', label: 'Oruro' },
            { value: 'PA', label: 'Pando' },
            { value: 'PT', label: 'Potosi' },
            { value: 'SC', label: 'Santa Cruz' },
            { value: 'TJ', label: 'Tarija' },
            { value: 'EXT', label: 'Extranjero' }
        ];
        return (
            <OgaSelect
                bsSize="large"
                placeholder="Seleccione Departamento"
                value={this.props.selection}
                onChange={(status) => this.handleChange(status)}
                options={statuses}
            />
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/CIExpSelect/DptSelect.jsx